export default __webpack_public_path__ + "static/media/ProposalCreate.9253176a.svg";